import { observer } from 'mobx-react'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PayrollIssuesTable from 'modules/payroll_bundle/components/PayrollIssuesTable'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'

const PayrollIssuesPage = () => {
  const { currentPeriod } = usePolicyPeriods()

  // This situation is resolved by the PayrollManagementPage so we can ignore it here.
  if (!currentPeriod) return null

  return (
    <ResponsivePage.Body>
      <PayrollIssuesTable policyPeriodId={currentPeriod.id} />
    </ResponsivePage.Body>
  )
}

export default observer(PayrollIssuesPage)
